import { useEffect, useState } from "react";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import Cookies from "js-cookie";

export default function useShowGiftNofitifcationUpdate() {
  const OKTAUserInfo = useOKTAUserStore((store) => store.userInfo);
  const [showGiftNotification, setShowGiftNotification] = useState(false);

  const isSubscriber = OKTAUserInfo?.usertype === OKTAUserTypeEnum.SUBSCRIBER;

  useEffect(() => {
    const giftAnArticleNotified = Cookies.get("giftAnArticleNotified");

    if (typeof giftAnArticleNotified !== "undefined") return;
    if (!isSubscriber) return;

    setShowGiftNotification(true);
  }, [setShowGiftNotification, isSubscriber]);

  return { showGiftNotification, setShowGiftNotification };
}
